import { Configuration, RedirectRequest } from "@azure/msal-browser";
import { getRedirectStartPage } from "./authRedirect";

export interface AuthSettings {
  domain: string;
  azure_tenant_id: string;
  azure_client_id: string;
}

export function createMsalConfig(settings: AuthSettings): Configuration {
  return {
    auth: {
      clientId: settings.azure_client_id,
      authority: `https://login.microsoftonline.com/${settings.azure_tenant_id}`,
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
      postLogoutRedirectUri: window.location.origin
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    }
  };
}

export function createLoginRequest(settings: AuthSettings): RedirectRequest {
  return {
    redirectStartPage: getRedirectStartPage(),
    scopes: [
      "User.Read",

      "Calendars.Read",
      "Calendars.Read.Shared",
      "Channel.ReadBasic.All",
      "ChannelMember.Read.All",
      "ChannelMessage.Read.All",
      "Chat.Read",
      "ChatMessage.Read",
      "Mail.Read",
      "Mail.Read.Shared",
      "MailboxSettings.Read",
      "Team.ReadBasic.All",

      `api://${settings.domain}/${settings.azure_client_id}/user_impersonation`
    ]
  };
}

export const graphRequest = {
  scopes: ["User.Read"]
};

export const graphPhotoRequest = {
  scopes: ["User.Read"]
};
